import React from "react"

import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'

import Phone from '../../../utils/Phone'

export default class CustomPhoneInput extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      value: this.props.value
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      ...nextProps,
      value: this.state.value
    })
  }

  _handlePhoneUpdate(value, data, e, formattedValue){
    this.setState({
      value: formattedValue,
    })
    if(this.props.onChange){
      this.props.onChange(value, data, e, formattedValue)
    }
  }


  render() {

    return (
      <PhoneInput
        {...this.props}
        country={Phone.getDefaultCountryIsoCode()}
        value={this.state.value}
        enableLongNumbers={true}
        onChange={(value, data, e, formattedValue) => this._handlePhoneUpdate(value, data, e, formattedValue)}
        priority={Phone.getCountryIsoCodePriority()}
      />
    )
  }

}
